export default __webpack_public_path__ + "static/media/comment.93c95b10.md";